/**
 * WalkAndPunch API
 * This is the WalkAndPunch API
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CustomTemplateViewModel } from '../model/customTemplateViewModel';
import { ExportViewModel } from '../model/exportViewModel';
import { ExportWithMimeTypeViewModel } from '../model/exportWithMimeTypeViewModel';
import { MasterViewModel } from '../model/masterViewModel';
import { V1CustomTemplateBody } from '../model/v1CustomTemplateBody';
import { V1CustomTemplateBody1 } from '../model/v1CustomTemplateBody1';
import { V1CustomTemplateBody2 } from '../model/v1CustomTemplateBody2';
import { V1CustomTemplateBody3 } from '../model/v1CustomTemplateBody3';
import { V1CustomTemplateBody4 } from '../model/v1CustomTemplateBody4';
import { V1CustomTemplateBody5 } from '../model/v1CustomTemplateBody5';
import { V1CustomTemplateBody6 } from '../model/v1CustomTemplateBody6';
import { V1CustomTemplateBody7 } from '../model/v1CustomTemplateBody7';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CustomTemplateService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param customTemplateId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public _delete(customTemplateId?: number, observe?: 'body', reportProgress?: boolean): Observable<CustomTemplateViewModel>;
    public _delete(customTemplateId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustomTemplateViewModel>>;
    public _delete(customTemplateId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustomTemplateViewModel>>;
    public _delete(customTemplateId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (customTemplateId !== undefined && customTemplateId !== null) {
            queryParameters = queryParameters.set('customTemplateId', <any>customTemplateId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<CustomTemplateViewModel>('delete',`${this.basePath}/v1/CustomTemplate`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public create(body?: V1CustomTemplateBody4, observe?: 'body', reportProgress?: boolean): Observable<CustomTemplateViewModel>;
    public create(body?: V1CustomTemplateBody4, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustomTemplateViewModel>>;
    public create(body?: V1CustomTemplateBody4, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustomTemplateViewModel>>;
    public create(body?: V1CustomTemplateBody4, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CustomTemplateViewModel>('post',`${this.basePath}/v1/CustomTemplate`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param customTemplateId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadCustomTemplate(customTemplateId?: number, observe?: 'body', reportProgress?: boolean): Observable<ExportWithMimeTypeViewModel>;
    public downloadCustomTemplate(customTemplateId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ExportWithMimeTypeViewModel>>;
    public downloadCustomTemplate(customTemplateId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ExportWithMimeTypeViewModel>>;
    public downloadCustomTemplate(customTemplateId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (customTemplateId !== undefined && customTemplateId !== null) {
            queryParameters = queryParameters.set('customTemplateId', <any>customTemplateId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ExportWithMimeTypeViewModel>('post',`${this.basePath}/v1/CustomTemplate/downloadCustomTemplate`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param customTemplateId 
     * @param timezone 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportCustomTemplate(body?: Array<number>, customTemplateId?: number, timezone?: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public exportCustomTemplate(body?: Array<number>, customTemplateId?: number, timezone?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public exportCustomTemplate(body?: Array<number>, customTemplateId?: number, timezone?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public exportCustomTemplate(body?: Array<number>, customTemplateId?: number, timezone?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (customTemplateId !== undefined && customTemplateId !== null) {
            queryParameters = queryParameters.set('customTemplateId', <any>customTemplateId);
        }
        if (timezone !== undefined && timezone !== null) {
            queryParameters = queryParameters.set('timezone', <any>timezone);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/v1/CustomTemplate/exportCustomTemplate`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param customTemplateSourceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAvailablePlaceholdersByType(customTemplateSourceId?: number, observe?: 'body', reportProgress?: boolean): Observable<ExportViewModel>;
    public getAvailablePlaceholdersByType(customTemplateSourceId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ExportViewModel>>;
    public getAvailablePlaceholdersByType(customTemplateSourceId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ExportViewModel>>;
    public getAvailablePlaceholdersByType(customTemplateSourceId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (customTemplateSourceId !== undefined && customTemplateSourceId !== null) {
            queryParameters = queryParameters.set('customTemplateSourceId', <any>customTemplateSourceId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ExportViewModel>('get',`${this.basePath}/v1/CustomTemplate/allAvailablePlaceholders`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getByProjectTemplate(observe?: 'body', reportProgress?: boolean): Observable<Array<CustomTemplateViewModel>>;
    public getByProjectTemplate(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CustomTemplateViewModel>>>;
    public getByProjectTemplate(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CustomTemplateViewModel>>>;
    public getByProjectTemplate(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<CustomTemplateViewModel>>('get',`${this.basePath}/v1/CustomTemplate/GetByProyectTemplate`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param customTemplateSourceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getByProjectTemplateAndSource(customTemplateSourceId?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<MasterViewModel>>;
    public getByProjectTemplateAndSource(customTemplateSourceId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterViewModel>>>;
    public getByProjectTemplateAndSource(customTemplateSourceId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterViewModel>>>;
    public getByProjectTemplateAndSource(customTemplateSourceId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (customTemplateSourceId !== undefined && customTemplateSourceId !== null) {
            queryParameters = queryParameters.set('customTemplateSourceId', <any>customTemplateSourceId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<MasterViewModel>>('get',`${this.basePath}/v1/CustomTemplate/GetByProyectTemplateSource`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSources(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterViewModel>>;
    public getSources(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterViewModel>>>;
    public getSources(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterViewModel>>>;
    public getSources(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<MasterViewModel>>('get',`${this.basePath}/v1/CustomTemplate/Sources`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public update(body?: V1CustomTemplateBody, observe?: 'body', reportProgress?: boolean): Observable<CustomTemplateViewModel>;
    public update(body?: V1CustomTemplateBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustomTemplateViewModel>>;
    public update(body?: V1CustomTemplateBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustomTemplateViewModel>>;
    public update(body?: V1CustomTemplateBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CustomTemplateViewModel>('put',`${this.basePath}/v1/CustomTemplate`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
